// extracted by mini-css-extract-plugin
export default {"main":"Layout_main__RMyn6","navigator":"Layout_navigator__DL0iC"};